import React, { useState, useEffect } from 'react'
import Breadcrumb from '../../../../Components/Breadcrumb/Breadcrumb'
import EvnVar from '../../../../EnvVar';
import Cookies from 'js-cookie';
import axios from 'axios';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';

function Allocation() {
    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    const baseURL = EvnVar()
    const [ccmData, setccmData] = useState([])
    const [branch, setBranch] = useState([])
    useEffect(() => {
        const token = Cookies.get("jwt");
        function fetchingCCM() {
            let config = {
                method: "get",
                maxBodyLength: Infinity,
                url: `${baseURL}/user/getCCM`,
                headers: {
                    Authorization: token,
                },
                withCredentials: true,
            };

            axios
                .request(config)
                .then((response) => {
                    let result = JSON.stringify(response.data);
                    let data = JSON.parse(result);
                    setccmData(data);
                    // console.log("Get CCM data", data);
                })
                .catch((error) => {
                    console.log("Error fetching on CCM data:", error);
                });
        }

        fetchingCCM()

        function fetchingBranch() {
            let config = {
                method: "get",
                maxBodyLength: Infinity,
                url: `${baseURL}/user/getBranches`,
                headers: {
                    Authorization: token,
                },
                withCredentials: true,
            };

            axios
                .request(config)
                .then((response) => {
                    let result = JSON.stringify(response.data);
                    let data = JSON.parse(result);
                    setBranch(data);
                    // console.log("Get branch data", data);
                })
                .catch((error) => {
                    console.log("Error fetching on branch data:", error);
                });
        }
        fetchingBranch()
    }, []);

    const [allcated, setAllcated] = useState()

    const allcatedButton = (e) => {
        // console.log("e.target", e.target.id);
        setAllcated(e.target.id)
    }

    const [selectedItems, setSelectedItems] = useState([]);

    const handleCheckboxChange = (itemId) => {
        setSelectedItems((prevSelectedItems) => {
            if (prevSelectedItems.includes(itemId)) {
                // If the item is already selected, remove it
                return prevSelectedItems.filter((id) => id !== itemId);
            } else {
                // If the item is not selected, add it
                return [...prevSelectedItems, itemId];
            }
        });
    };

    const [successMessage, setSuccessMessage] = useState()
    const [errorMessage, setErrorMessage] = useState()
    const submitBranch = (e) => {
        e.preventDefault();
        const token = Cookies.get("jwt");
        let finalAllocationsBranches = JSON.stringify({
            "ids": selectedItems,
            "orgination_id": Number(allcated)
        });

        let config = {
            method: 'put',
            maxBodyLength: Infinity,
            url: `${baseURL}/user/updateOrgId`,
            headers: {
                Authorization: token,
                'content-type': 'application/json'
            },
            withCredentials: true,
            data: finalAllocationsBranches
        };

        // console.log("finalAllocationsBranches", finalAllocationsBranches);

        axios.request(config)
            .then((response) => {
                const feedbackMessage = JSON.stringify(response.data)
                const stringifyFeedbackMessage = JSON.parse(feedbackMessage)
                // console.log(stringifyFeedbackMessage.message);
                setSuccessMessage(stringifyFeedbackMessage.message)
                setTimeout(() => {
                    setSuccessMessage()
                }, 4000);
            })
            .catch((error) => {
                console.log(error.message);
                setErrorMessage(error.message)
                setTimeout(() => {
                    setErrorMessage()
                }, 4000);
            });
    }

    // console.log("selectedItems", selectedItems, allcated);
    return (
        <>
            <Breadcrumb data="Allocation" />
            <div className='content-body'>
                {successMessage && <div className='text-success' style={{ position: "absolute", top: "100px", right: "0", fontWeight: "500", backgroundColor: "#fff", padding: "0.75rem 2rem", boxShadow: "0 0 6px 3px #ddd", borderRadius: "10px 0 0 10px", transition: "ease-in-out 0.5s" }}>{successMessage}</div>}
                {errorMessage && <div className='text-danger' style={{ position: "absolute", top: "100px", right: "0", fontWeight: "500", backgroundColor: "#fff", padding: "0.75rem 2rem", boxShadow: "0 0 6px 3px #ddd", borderRadius: "10px 0 0 10px", transition: "ease-in-out 0.5s" }}>{errorMessage}</div>}
                <div className="table-data">
                    <div className='table-responsive'>
                        <table className='table table-bordered'>
                            <thead>
                                <tr>
                                    <th>ID</th>
                                    <th>Name</th>
                                    <th>Allocate</th>
                                </tr>
                            </thead>
                            <tbody>
                                {ccmData && ccmData.map((value, index) => (
                                    <tr key={index}>
                                        <td>{value.id}</td>
                                        <td>{value.email}</td>
                                        <td><button variant="primary" onClick={(e) => { handleShow(); allcatedButton(e) }} id={value.id} className='download-btn'>Allocate</button></td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>


            <Modal show={show} centered size="xl" onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>Branches</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <form onSubmit={submitBranch}>
                        <div className="table-data">
                            <div className='table-responsive branches-tables'>
                                <table className='table table-bordered'>
                                    <thead>
                                        <tr>
                                            <th>ID</th>
                                            <th>Name</th>
                                            <th>Email</th>
                                            <th>Allocate</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {branch && branch.map((value, index) => (
                                            <tr key={index}>
                                                <td>{value.id}</td>
                                                <td>{value.name}</td>
                                                <td>{value.email}</td>
                                                <td><input
                                                    style={{ width: "25px" }}
                                                    type="checkbox"
                                                    checked={selectedItems.includes(value.id)}
                                                    onChange={() => handleCheckboxChange(value.id)}
                                                /></td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <Button variant="primary" type='submit'
                            onClick={handleClose}
                        >
                            Submit
                        </Button>
                    </form>
                </Modal.Body>
            </Modal>
        </>
    )
}

export default Allocation
